import Vue from "vue";
import VueResource from "vue-resource";
import VeeValidate from "vee-validate";
import Moment from "moment";
import VueDirectives from "@/services/directives";
import VueFeather from "vue-feather";
import swal from "sweetalert";
import Loading from "vue-loading-overlay";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "./registerServiceWorker";

import "materialize-css/dist/js/materialize.min";
import "materialize-css/dist/css/materialize.css";

import Dictionary from "@/config/vee-validate/dictionary";
import "moment/locale/pt-br";

import "@/assets/scss/main.scss";
import "@/config/registerComponents";
import "@/config/vee-validate/customRules";
import "vue-swatches/dist/vue-swatches.min.css";
import "vue-loading-overlay/dist/vue-loading.css";

import "animate.css";

import interceptor from "@/services/interceptors";
import filterCpfCnpj from "@/services/filters/cpfCnpj";

Vue.filter(filterCpfCnpj.name, filterCpfCnpj.filter);

interceptor();

Moment.locale("pt-BR");

Vue.use(VeeValidate, {
  locale: "pt",
  dictionary: Dictionary,
  events: "change|mask"
});
Vue.use(VueResource);
Vue.use(VueFeather);
Vue.use(Loading);
Vue.use(VueDirectives);
Vue.http.options.root = process.env.VUE_APP_URL_API;
Vue.prototype.$moment = Moment;
Vue.config.productionTip = false;
Vue.prototype.$swal = swal;

if (process.env.VUE_APP_ENV === "development") {
  require("@/plugins/mirage").makeServer();
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
